import { Availability } from '../domain/Availability'
import { AvailabilityDTO } from './DTOs/AvailabilityDTO'
import { DTOAdapter } from './DTOs/DTOAdapter'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'projects/booking/src/environments/environment'
import { VenueOpenDay } from '../domain/VenueOpenDaysCalendar'
import { VenueOpenDaysDTO } from './DTOs/VenueOpenDaysDTO'
import { map } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class AvailabilityService {

    private baseURL = environment.apiBaseUrl

    constructor(
        private http: HttpClient,
        private dtoAdapter: DTOAdapter
    ) {}

    getAvailability(
        organisationId: string,
        businessId: string,
        venueId: string,
        startDate: Date,
        endDate: Date,
        updatingBookingId?: string,
        requiresWheelchairAccess?: boolean,
        requiresDogFriendly?: boolean,
        requiresPramAccessible?: boolean,
        requiresHighchairFriendly?: boolean,
        restrictedReasonIds?: string[]
    ): Observable<Availability> {
        let startDateString = this.makeLocalISOFormattedDateString(startDate)
        let endDateString = this.makeLocalISOFormattedDateString(endDate)
        let params = new HttpParams()
            .set('startDate', startDateString)
            .set('endDate', endDateString)
        if (updatingBookingId) {
            params = params.set('updatingBookingId', updatingBookingId)
        }
        if (requiresWheelchairAccess !== undefined) {
            params = params.set('requiresWheelchairAccess', requiresWheelchairAccess.toString())
        }
        if (restrictedReasonIds) {
            params = params.set('restrictedReasonIds', restrictedReasonIds.join(','))
        }
        if (requiresDogFriendly !== undefined) {
            params = params.set('requiresDogFriendly', requiresDogFriendly.toString())
        }
        if (requiresPramAccessible !== undefined) {
            params = params.set('requiresPramAccessible', requiresPramAccessible.toString())
        }
        if (requiresHighchairFriendly !== undefined) {
            params = params.set('requiresHighchairFriendly', requiresHighchairFriendly.toString())
        }
        let path = `
/booking\
/organisation/${encodeURIComponent(organisationId)}\
/business/${encodeURIComponent(businessId)}\
/venue/${encodeURIComponent(venueId)}\
/booking-slot-availability\
?${params.toString()}
    `
        let url = new URL(path, this.baseURL)
        return this.http.get<AvailabilityDTO>(url.toString())
            .pipe(
                map(dto => this.dtoAdapter.adaptAvailabilityDto(dto))
            )
    }

    getOpenDays(
        organisationId: string,
        businessId: string,
        venueId: string,
        startDate: Date, 
        endDate: Date
    ): Observable<VenueOpenDay[]> {
        const startDateString = this.makeLocalISOFormattedDateString(startDate)
        const endDateString = this.makeLocalISOFormattedDateString(endDate)
        const params = new HttpParams()
            .set('startDate', startDateString)
            .set('endDate', endDateString)
        const path = `/booking/organisation/${encodeURIComponent(organisationId)}/business/${encodeURIComponent(businessId)}/venue/${encodeURIComponent(venueId)}/open-days?${params.toString()}`
        const url = new URL(path, this.baseURL)
        return this.http.get<VenueOpenDaysDTO>(url.toString())
            .pipe(
                map(dto => dto.days.map(day => ({ date: day.date, open: day.open })))
            )
    }

    private makeLocalISOFormattedDateString(date: Date): string {
        let offsetMs = date.getTimezoneOffset() * 60 * 1000
        let msLocal =  date.getTime() - offsetMs
        let dateLocal = new Date(msLocal)
        let iso = dateLocal.toISOString()
        let [isoLocal] = iso.split('T')
        return isoLocal
    }
}
